import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.node)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getNodeComponent($setup.node.data.component)), {
        key: 0,
        node: $setup.node
      }, null, 8 /* PROPS */, ["node"]))
    : _createCommentVNode("v-if", true)
}